export default __webpack_public_path__ + "static/media/KAAN01.7641a1be.png";